const consumerCarleadStatuses = {
  ONSITE_PRICE_GIVEN: 15
};
export default consumerCarleadStatuses;